
import { Typography, Box } from '@mui/material';
import { height, width } from '@mui/system';


var Barcode = require('react-barcode');
// https://www.npmjs.com/package/react-barcode

//

// {
//   width: 2,
//   height: 100,
//   format: "CODE128",
//   displayValue: true,
//   fontOptions: "",
//   font: "monospace",
//   textAlign: "center",
//   textPosition: "bottom",
//   textMargin: 2,
//   fontSize: 20,
//   background: "#ffffff",
//   lineColor: "#000000",
//   margin: 10,
//   marginTop: undefined,
//   marginBottom: undefined,
//   marginLeft: undefined,
//   marginRight: undefined,
//   id: undefined,
//   className: undefined
// }



const HandlingUnit = ({ shipmentOrderCode, consigneeCode, huCode, pageIdx }) => {

    const style = {
        pageBreakAfter: 'always',
        padding: '20px',
        // border: '1px solid black', 
        marginBottom: '20px',
        alignContent: 'center',
        textAlign: 'center',
        height: '90vh',
    }

    return (
        <Box style={style}>
            <Typography variant="h1" sx={{ fontWeight: 700 }} >{shipmentOrderCode}</Typography>
            <Typography variant="h3" >{consigneeCode}</Typography>

            <Barcode style={{ format: "CODE39", }} value={`${shipmentOrderCode}-${huCode}`} />

            <Box sx={{ display: 'flex', justifyContent: 'right', alignItems: 'center', marginTop: '10px', marginRight: '100px' }}>
                <Typography variant="h3" >{pageIdx}</Typography>
            </Box>

        </Box>
    );
}


const HuLabel = ({ dataShipement, contentRef, currentHuId, pageIdx=null }) => {

    const shipmentOrderCode = dataShipement.shipmentOrderCode || '';
    const consigneeCode = dataShipement.consignee?.code || '';

    let handlingUnits = []
    if (currentHuId) {
        handlingUnits = dataShipement.handlingUnits.filter(i => i._id === currentHuId) || [];
    } else {
        handlingUnits = dataShipement.handlingUnits || [];
    }

    const totalHu = handlingUnits.length;

    return (
        <div ref={contentRef}>
            {handlingUnits.map((hu, index) => (
                <HandlingUnit key={index} shipmentOrderCode={shipmentOrderCode} consigneeCode={consigneeCode} huCode={hu.huCode} pageIdx={pageIdx ? pageIdx : `${index + 1}/${totalHu}`} />
            ))}
        </div>
    );
}

export default HuLabel;
